export enum Area {
    ALL = 'all',
    WORK = 'work',
    HEALTH = 'health',
    FAMILY = 'family',
    PENSION = 'pension',
    SOCIAL_COUNSELLING = 'social_counselling',
    ACCESSIBILITY = 'accessibility',
    RECRUITMENT = 'recruitment',
    INCLUSION = 'inclusion',
    DOWNSIZING = 'downsizing',
    OTHER = 'other',
}
